export default "__VITE_ASSET__DUcdA3Ot__"